/**
 * Rate limit indicator badge
 */

import { useState, useEffect } from 'react';
import { Zap } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { getRateLimit } from '@/lib/photo-api';
import { cn } from '@/lib/utils';

export function RateLimitBadge() {
  const [remaining, setRemaining] = useState<number | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchRateLimit = async () => {
      try {
        const data = await getRateLimit();
        setRemaining(data.remaining);
        setError(false);
      } catch {
        setError(true);
      }
    };

    fetchRateLimit();
    const interval = setInterval(fetchRateLimit, 30000); // Poll every 30s
    return () => clearInterval(interval);
  }, []);

  if (error) {
    return (
      <Badge variant="outline" className="text-muted-foreground">
        <Zap className="w-3 h-3 mr-1" />
        API Offline
      </Badge>
    );
  }

  if (remaining === null) {
    return (
      <Badge variant="outline" className="text-muted-foreground">
        <Zap className="w-3 h-3 mr-1" />
        Loading...
      </Badge>
    );
  }

  const variant = remaining < 10 ? 'destructive' : remaining < 25 ? 'secondary' : 'default';

  return (
    <Badge
      variant={variant}
      className={cn(
        remaining >= 25 && 'bg-green-600 hover:bg-green-700'
      )}
    >
      <Zap className="w-3 h-3 mr-1" />
      {remaining}/50 requests
    </Badge>
  );
}
